import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router';

export function useCoachStudioParams() {
  const { pathname } = useLocation();
  const { id } = useParams() as { id: string };

  const isCoachUrl = useMemo(() => pathname.match(/^\/coach\/\d*$/g), [pathname]);
  const isStudioUrl = useMemo(() => pathname.match(/^\/studio\/\d*$/g), [pathname]);

  return { id: parseInt(id), isCoachUrl, isStudioUrl };
}
